export default __webpack_public_path__ + "static/media/IMG_6706.092a18d6.png";